<template lang="pug">
  transition(name='modal')
    .modal-mask(@click="modalMask")
      form.modal
        a(href='#' @click.prevent="$emit('close')").modal__close
          svgicon(name='close')
        .modal__header
          slot(name='header')
            | default header
        .modal__body
          slot(name='body')
            | default body
        .modal__footer
          slot(name='footer')
            button.btn(@click.prevent="$router.push({ name: 'NewAddRow' })") Сохранить

</template>

<script>
export default {
  name: 'Modal',
  methods: {
    modalMask: function() {
      if (event.target.classList.contains('modal-mask')) {
        return this.$emit('close');
      }
    }
  }
}
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(196, 202, 214, 0.8);
  display: flex;
  flex-direction: column;
  transition: opacity 0.3s ease;
}

.modal {
  width: 400px;
  max-width: 100%;
  margin: auto;
  padding: 20px 30px;
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #fff;
  transition: all 0.3s ease;
  position: relative;
    box-sizing: border-box;
  &__close{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 16px;
    height: 16px;
    color: #161616;
    &:hover{
      color: #008cff;
      .svg-icon{
        transform: rotate(180deg);
      }
    }
    .svg-icon{
      display: block;
      transition: transform 0.35s;
    }
  }
}

.modal__header h3 {
  margin-top: 0;
  color: #161616;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 25px;
}

.modal__body {
  margin: 20px 0;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal,
.modal-leave-active .modal {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
